import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import StreamedList from '../../StreamedList';
import GallectionListItemCheckbox from '../../GallectionListItem/GallectionListItemCheckbox';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
import { isSpecialDefaultGallection } from '../../helpers/gallections';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './CollectionList.scss';
const CollectionsList = ({ collectibleDeviation, isPrivateCollections, selectedFolderIds, collections, filterValue, headerContent, isFetching, streamId, isInitialized, allDisabled, toggleCollection: toggleCollectionProp })=>{
    const { t } = useTranslation();
    const hasCoreMembership = useSelector(getCurrentUserHasCore);
    const toggleCollection = useCallback(({ folderId })=>{
        yieldToMain(()=>{
            toggleCollectionProp(folderId, collectibleDeviation.deviationId, isPrivateCollections);
        });
    }, [
        collectibleDeviation.deviationId,
        toggleCollectionProp,
        isPrivateCollections
    ]);
    const collectionsFiltered = collections.filter((collection)=>{
        return collection && (!filterValue || collection.name.toLowerCase().includes(filterValue.toLowerCase()));
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, headerContent, /*#__PURE__*/ React.createElement(StreamedList, {
        streamId: streamId,
        className: s['list'],
        wrapperClassName: s['scrollable'],
        skipInitialFetch: true
    }, collectionsFiltered.map((collection)=>/*#__PURE__*/ React.createElement(GallectionListItemCheckbox, {
            className: s['item'],
            key: collection.folderId,
            checked: selectedFolderIds && selectedFolderIds.includes(collection.folderId),
            disabled: allDisabled || isPrivateCollections && !hasCoreMembership && !isSpecialDefaultGallection(collection),
            gallection: collection,
            subLabel: t('common.deviationCount', {
                count: collection.size
            }),
            onChange: toggleCollection
        })), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['loader']
    }), isInitialized && !isFetching && filterValue && collectionsFiltered.length === 0 && /*#__PURE__*/ React.createElement("div", {
        className: s['empty']
    }, t('addToCollectionPopover.empty.noResults'))));
};
export default CollectionsList;
